/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type CheckHardwareRequestAvailabilityQueryVariables = Types.Exact<{
  request_id: Types.Scalars["Float"];
}>;

export type CheckHardwareRequestAvailabilityQuery = {
  checkHardwareRequestAvailability: Pick<
    Types.HardwareRequestAvailabilityCheck,
    "request_id" | "can_approve_fully" | "total_items" | "available_items"
  > & {
    items: Array<
      Pick<
        Types.HardwareItemAvailabilityStatus,
        | "hardware_item_id"
        | "sku_name"
        | "sku_code"
        | "requested_quantity"
        | "available_quantity"
        | "can_fulfill"
        | "shortage_amount"
      >
    >;
  };
};

export const CheckHardwareRequestAvailabilityDocument = gql`
  query CheckHardwareRequestAvailability($request_id: Float!) {
    checkHardwareRequestAvailability(request_id: $request_id) {
      request_id
      can_approve_fully
      total_items
      available_items
      items {
        hardware_item_id
        sku_name
        sku_code
        requested_quantity
        available_quantity
        can_fulfill
        shortage_amount
      }
    }
  }
`;

/**
 * __useCheckHardwareRequestAvailabilityQuery__
 *
 * To run a query within a React component, call `useCheckHardwareRequestAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckHardwareRequestAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckHardwareRequestAvailabilityQuery({
 *   variables: {
 *      request_id: // value for 'request_id'
 *   },
 * });
 */
export function useCheckHardwareRequestAvailabilityQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    CheckHardwareRequestAvailabilityQuery,
    CheckHardwareRequestAvailabilityQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    CheckHardwareRequestAvailabilityQuery,
    CheckHardwareRequestAvailabilityQueryVariables
  >(CheckHardwareRequestAvailabilityDocument, baseOptions);
}
export function useCheckHardwareRequestAvailabilityLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CheckHardwareRequestAvailabilityQuery,
    CheckHardwareRequestAvailabilityQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    CheckHardwareRequestAvailabilityQuery,
    CheckHardwareRequestAvailabilityQueryVariables
  >(CheckHardwareRequestAvailabilityDocument, baseOptions);
}
export type CheckHardwareRequestAvailabilityQueryHookResult = ReturnType<
  typeof useCheckHardwareRequestAvailabilityQuery
>;
export type CheckHardwareRequestAvailabilityLazyQueryHookResult = ReturnType<
  typeof useCheckHardwareRequestAvailabilityLazyQuery
>;
export type CheckHardwareRequestAvailabilityQueryResult =
  ApolloReactCommon.QueryResult<
    CheckHardwareRequestAvailabilityQuery,
    CheckHardwareRequestAvailabilityQueryVariables
  >;
